var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copiar_datos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 34,
    height: 34,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    fill: "#fff",
    stroke: "#8eae41",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 4,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_45",
    "data-name": "Mask Group 45",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_clone_",
    "data-name": "FontAwsome (clone)",
    d: "M16.012,0H4.969A1.656,1.656,0,0,0,3.313,1.656V3.313H1.656A1.656,1.656,0,0,0,0,4.969V16.012a1.656,1.656,0,0,0,1.656,1.656H12.7a1.656,1.656,0,0,0,1.656-1.656V14.356h1.656A1.656,1.656,0,0,0,17.669,12.7V1.656A1.656,1.656,0,0,0,16.012,0Zm-3.52,16.012H1.863a.207.207,0,0,1-.207-.207V5.176a.207.207,0,0,1,.207-.207H3.313V12.7a1.656,1.656,0,0,0,1.656,1.656H12.7v1.449A.207.207,0,0,1,12.492,16.012ZM15.805,12.7H5.176a.207.207,0,0,1-.207-.207V1.863a.207.207,0,0,1,.207-.207H15.805a.207.207,0,0,1,.207.207V12.492A.207.207,0,0,1,15.805,12.7Z",
    transform: "translate(8.166 8)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.27664b6d7d7bab57429904261499d4e8.svg";
export { ForwardRef as ReactComponent };